import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { RootState, ThunkServices } from '../../app/store';


// State
export interface PickupState {
    locations: endpoints.LocationDTO;
    loading: boolean;
}

export const initialState: PickupState = {
    locations: {},
    loading: false,
};

// Thunks
export const getPickupLocations = createAsyncThunk<
    endpoints.LocationDTO, // Return type of the thunk
    void, // Argument type (none in this case)
    { state: RootState;
        extra: ThunkServices } // ThunkAPI configuration
>('pickup/getPickupLocations', async (_, { extra: { pickupService } }) => {
    const response = await pickupService.getLocations();
    return response;
});

// Slice
export const pickupSlice = createSlice({
    name: 'pickup',
    initialState,
    reducers: {
        setPickupLocations: (state, action: PayloadAction<{locations: endpoints.LocationDTO}> ) => {
            state.locations = action.payload.locations;
        },
        setPickupLocationsLoading: (state, action: PayloadAction<{loading :boolean}> ) => {
            if (action.payload.loading !== undefined) {
                state.loading = action.payload.loading;
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPickupLocations.pending, (state) => {
                state.loading = true; // Automatically set loading when the thunk is pending
            })
            .addCase(getPickupLocations.fulfilled, (state, action) => {
                state.locations = action.payload; // Update locations when the thunk is fulfilled
                state.loading = false; // Set loading to false
            })
            .addCase(getPickupLocations.rejected, (state) => {
                state.loading = false; // Set loading to false when the thunk is rejected
            });
    },
});

// Actions
export const { setPickupLocations, setPickupLocationsLoading } = pickupSlice.actions;

// Reducer
export const pickupReducer = pickupSlice.reducer;